export default "__VITE_ASSET__CvfQuMlk__"